import { CompaniesActions, CompaniesActionTypes } from "../actions";

export interface State {
  name: string;
  id: string;
  alphaname: string;
  email: string;
  did: string;
  billingId: string;
}

export const initialState = {
  name: '',
  id: '',
  alphaname: '',
  email: '',
  did: '',
  billingId: ''
};

export function reducer(state = initialState, action: CompaniesActions): State {
  switch (action.type) {
    case CompaniesActionTypes.SetFilters: {
      let filter = action.payload;
      return {
        ...state,
        name: filter.name,
        id: filter.id,
        alphaname: filter.alphaname,
        email: filter.email,
        did: filter.did,
        billingId: filter.billingId
      };
    }
    default:
      return state;
  }
}
